import {RestResource} from '../rest'
import {KPI_SERVER} from '../server'
import {athubAxios} from '../../util'

const kpi = new RestResource({server: KPI_SERVER, resource: 'kpi'});

export default kpi;